var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svgContent",attrs:{"id":"svgWorkPlatform"},domProps:{"innerHTML":_vm._s(_vm.svgHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }